// src/Routes/AuthProtected.jsx
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { decrypt } from '../xor';
import LoginModal from '../Components/LoginModal'; // убедитесь, что этот компонент существует

const AuthProtected = ({ children }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false); // unused

  useEffect(() => {
    const authenticate = async () => {
      setIsLoading(true);
      let authToken = localStorage.getItem("auth_token");
      if (!authToken) {
        setShowLoginModal(true);
        setIsLoading(false);
        return;
      }

      try {
        const dec = decrypt(authToken, "aRandomSecretKey");
        if (dec) {
          setIsAuthenticated(true);
        } else {
          setShowLoginModal(true);
        }
      } catch (error) {
        console.error("Error decrypting auth token:", error);
        setShowLoginModal(true);
      } finally {
        setIsLoading(false);
      }
    };

    authenticate();
  }, [location.search]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Если текущий путь /clock_ic – просто показываем ошибку, не выводя модальное окно
    if (location.pathname === '/clock_ic') {
      return <div>This page is only accessible from Telegram Web App on a phone.</div>;
    }
    // Для остальных страниц показываем модальное окно для авторизации
    return (
      <LoginModal
        open={true}
        onLoginSuccess={(token, role) => {
          localStorage.setItem("auth_token", token);
          localStorage.setItem("userRole", role); // Сохраняем роль пользователя
          setIsAuthenticated(true);
          setShowLoginModal(false);
        }}
        
        onClose={() => {
          // Если пользователь закрывает модалку, можно перенаправить на страницу ошибки или логина
          // В данном примере просто ничего не показываем
        }}
      />
    );
  }

  return children;
};

export default AuthProtected;
